import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import HomeDropDown from './HomeDropDown';
import CoursesDropDown from './CoursesDropDown';
import EventsDropDown from './EventsDropDown';
import BlogsDropDown from './BlogsDropDown';
import { Menu, MenuHandler, Button } from "@material-tailwind/react";
import PagesDropDown from './PagesDropDown';
import EnSavoirPlus from './EnSavoirPlus';

const menuItems = [
    { name: 'Bootcamp', link: '/bootcamp' },
    { name: 'Little Maker', link: '/little-maker' },
    { name: 'Tutorat', link: '/tutorat' },
];

const getDropdownComponent = (item, mobile = false) => {
    switch (item) {
        case 'Courses': return <CoursesDropDown mobile={mobile} />;
        case 'En savoir plus': return <EnSavoirPlus mobile={mobile} />;
        case 'Blog': return <BlogsDropDown mobile={mobile} />;
        case 'Pages': return <PagesDropDown mobile={mobile} />;
        default: return null;
    }
};

function NavSubBar({ mobile = false, textColor }) {
    return (
        <div className={`${mobile ? 'flex flex-col space-y-2' : 'hidden md:flex space-x-1 mr-5'}`}>
            {menuItems.map((item) => (
                <Menu key={item.name} placement={mobile ? "bottom-start" : "bottom-start"}>
                    <MenuHandler>
                        <Button
                            variant="text"
                            className={`flex items-center ${textColor} dark:text-white hover:text-purple-1
                            ${mobile ? 'justify-between w-full py-2' : 'px-1'}`}
                        >
                            <a className='text-normal font-light dark:hover:text-purple-300' href={item.link}>{item.name}</a>
                        </Button>
                    </MenuHandler>
                    {getDropdownComponent(item.name, mobile)}
                </Menu>
            ))}
        </div>
    )
}

export default NavSubBar;